import Layout from "@/layout";
export default {
  meta: {
    title: "风险",
    icon: "b-fx",
  },
  path: "/riskNew",
  component: Layout,
  children: [
    {
      path: "/riskNew/RiskNew",
      name: "riskNew",
      component: () => import("@/views/RiskNew/RiskNew"),
      meta: {
        title: "风险管理",
        auth: [],
        img: "fx",
      },
    },
    {
      path: "/ClosedBx/index",
      name: "ClosedBx",
      component: () => import("@/views/ClosedManage/ClosedBx/index.vue"),
      meta: {
        title: "销项管理",
        auth: [],
        img: "zz",
      },
    },
    {
      path: "/RiskNew/DetailPage",
      name: "riskNewDetailPage",
      hide: true,
      component: () => import("@/views/RiskNew/DetailPage"),
      meta: {
        title: "风险详情",
        auth: [],
        img: "azx",
      },
      props: (route) => {
        return route.query;
      },
    },
    {
      path: "/sc/risk/ScIndex",
      name: "scRisk",
      component: () => import("@/views/serviceCenter/risk/ScIndex"),
      meta: {
        title: "风险管理",
        auth: [],
        img: "fx",
      },
    },
    {
      path: "/sc/risk/detail",
      name: "scRiskDetail",
      hide: true,
      component: () => import("@/views/serviceCenter/risk/detail"),
      meta: {
        title: "风险详情",
        auth: [],
        img: "azx",
      },
      props: (route) => route.query,
    },
    {
      path: "/sc/closed/ScIndex",
      name: "scClosed",
      component: () => import("@/views/serviceCenter/closed/ScIndex"),
      meta: {
        title: "销项管理",
        auth: [],
        img: "zz",
      },
    },
  ],
};
